import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import HeroBanner from './components/HeroBanner';
import FeaturedGrid from './components/FeaturedGrid';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '韩漫漫画网',
  url: 'http://ihua3.com/',
  description: '韩漫漫画网汇聚众多韩漫大全作品，推荐好看的韩国漫画免费在线观看，加载速度快画质清晰，是您探索韩漫世界的理想平台。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'http://ihua3.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '韩漫漫画网',
  url: 'http://ihua3.com/',
  description: '韩漫漫画网汇聚众多韩漫大全作品，推荐好看的韩国漫画免费在线观看，加载速度快画质清晰。',
};

const wpJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '韩漫大全_好看的韩国漫画_免费韩漫在线观看-韩漫漫画网',
  description: '韩漫漫画网汇聚众多韩漫大全作品，推荐好看的韩国漫画免费在线观看，加载速度快画质清晰，是您探索韩漫世界的理想平台。',
  url: 'http://ihua3.com/',
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(wpJsonLd)}</script>
      <SEOHead
        title="韩漫大全_好看的韩国漫画_免费韩漫在线观看-韩漫漫画网"
        description="韩漫漫画网汇聚众多韩漫大全作品，推荐好看的韩国漫画免费在线观看，加载速度快画质清晰，是您探索韩漫世界的理想平台。"
        keywords="韩漫大全,好看的韩国漫画,免费韩漫在线观看,韩漫漫画网"
        canonicalUrl="http://ihua3.com/"
      />
      <Navbar />
      <main>
        <HeroBanner />
        <FeaturedGrid />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}